import app from '../app.first';
import { each } from 'lodash';

app.SelectAutofill  = class extends app.Component {
	onReady() {
		this.firstLoad = true;

		this.$el.find('[data-select-map]').on('change', e => {
			let $option = $(e.target).find(':selected');

			each(this.$el.data('map'), map => {
				const $target = this.$el.find(map.targetSelector);
				$target.val($option.data(map.sourceKey));

				if (!this.firstLoad) {
					$target.trigger('change');
				}

				if ($option.data('disableTarget')) {
					$target.attr('disabled', true)
						.removeClass('is-invalid-input')
						.data('invalid', false)
						.removeAttr('data-invalid')
						.siblings('.is-invalid-label')
						.removeClass('is-invalid-label');
				}
				if ($option.data('enableTarget')) {
					$target.attr('disabled', false);
				}
			});

			this.firstLoad = false;
		}).trigger('change');
	}
}